import { GetEnabledModulesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

const useActiveSubscriptionOverload = (companyIds: [number]) => {
  const { data } = useQuery(GetEnabledModulesDocument, {
    variables: { companyIds },
  })

  const activeSubscriptionOverload = data?.companies.subscriptionOverloadsConnection.nodes[0]

  return { activeSubscriptionOverload }
}

export default useActiveSubscriptionOverload
